import React from 'react';
import { useLanguageCode } from './TranslationContext';
import { Helmet } from 'react-helmet';
export const HelmetTranslationProvider = _ref => {
  let {
    children
  } = _ref;
  const [languageCode] = useLanguageCode();
  if (languageCode) return React.createElement(React.Fragment, null, React.createElement(Helmet, null, React.createElement("html", {
    lang: languageCode
  })), children);else return null;
};